module.exports = __webpack_public_path__ + "img/2.4-北海公园唐槐（杨树田-摄）.dd662713.jpg";